import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomSpinnerRequestHeader } from "@app/custom-service/spinner-interceptor.service";
import { AppAutoCompleteModel } from "@app/custom-shared/components/form/app-auto-complete/app-auto-complete.component";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from 'src/environments/environment';
const BASE_PATH = environment.basePath;
import '@app/extensions/string.extensions';
@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  constructor(private httpClient: HttpClient) { }

  // getClients(header?: CustomSpinnerRequestHeader): Observable<AppAutoCompleteModel[]> {

  //   if (!header) header = new CustomSpinnerRequestHeader(true);

  //   return this.httpClient.get<DashboardClientModel[]>(
  //     `${BASE_PATH}/bff/master/users/create/clients/list`, { headers: header }
  //   ).pipe(
  //     map(
  //       (data: DashboardClientModel[]) => {
  //         return data.map((item) => {
  //           if (!item.institutionCode) item.institutionCode = "";
  //           return item;
  //         })
  //       }
  //     ),
  //     map(
  //       (data: DashboardClientModel[]) => {
  //         return data.sort((a, b) => {
  //           // Junta os dois nomes e usa ordenacao (Caso nao tenha fantasyName utiliza o legalName para ordenar)
  //           if (a.institutionCode.naturalNormalize() + a.legalName.naturalNormalize() > b.institutionCode.naturalNormalize() + b.legalName.naturalNormalize()) return 1;
  //           if (a.institutionCode.naturalNormalize() + a.legalName.naturalNormalize() < b.institutionCode.naturalNormalize() + b.legalName.naturalNormalize()) return -1;
  //           console.log("FIlter Data ",data)
  //           return 0;
  //         });
  //       }
  //     ),
  //     map(
  //       (data: DashboardClientModel[]) => {
  //         return data.map(
  //           clientItem => {
  //             return { label: this.getClientName(clientItem), value: clientItem.institutionCode };
  //           }
  //         ); //.filter((item) => item.value != null);
  //       }
  //     )
  //   );
  // }

  getClientName(client: DashboardClientModel) {
    const abbreviation: string = client.institutionCode ? `${client.institutionCode} - ` : "";
    return abbreviation + client.legalName;
  }
}

export interface DashboardClientModel {
  cnpj: string;
  fantasyName: string;
  id: string;
  institutionCode: string;
  legalName: string;
  permissionGroups: any[];
  totalFunds: number;
  totalUsers: number;
  name: string;
}
